import { PathInfos } from '@madeinlune/drupal-types';
import { DrupalIdentifier } from './drupal-node.model';
import { Expose, Transform } from 'class-transformer';
import { LanguageType } from '../languages.model';
import { PageTemplate } from './page-templates';

export class AppPathInfos extends DrupalIdentifier implements PathInfos {
  @Expose()
  language!: LanguageType;

  @Expose()
  path!: string;

  @Transform(({ obj }) => {
    return `${obj.path ?? ''}`;
  })
  @Expose()
  canonicalUrl!: string;

  @Transform(({ obj }) => {
    return obj?.title;
  })
  @Expose()
  title!: string;

  @Expose()
  description!: string;

  @Transform(({ obj }) => {
    return obj?.template;
  })
  @Expose()
  template?: PageTemplate;

  isFirstLevelMenuItem?: boolean;

  frontPage?: boolean;

  meta?: any;
}
